import { render, staticRenderFns } from "./HandoverOutput.vue?vue&type=template&id=00a5e3fb&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/apps/eneforhandler/components/contract/HandoverOutput.vue
// module id = null
// module chunks = 